import React from "react";
import Delete  from '../images/delete.png';
const DeleteButton = (props)=>{
    return(
        <button onClick={props.onClick} className="border-0 bg-body"><img src={Delete} alt="Delete"></img></button>
    )
}
export default DeleteButton;
